module.exports = __webpack_public_path__ + "img/logo_apc.507d47c4.png";